import { toast } from "@hortis/ui/sonner";
import * as A from "fp-ts/Array";
import type { UseQueryExecute } from "urql";
import type { CreateMaterialMutation } from "../../../../../../generated/graphql";

export const onUpdateAccessionSuccess =
  (text: string, callback: null | (() => Promise<void> | void)) => () => {
    toast.success(text);

    if (callback != null) {
      void callback();
    }
  };

export const onUpdateAccessionFailure = (error: Error) => {
  toast.error(error.message);
};

export const onCreateMaterialSuccess =
  (text: string, requestClose: () => void, refetch: UseQueryExecute) =>
  (_: CreateMaterialMutation) => {
    toast.success(text);

    refetch();

    requestClose();
  };

export const countFields = A.reduce(0, (prev, curr) =>
  curr == null ? prev : prev + 1,
);
